import { render } from "./AddDevice.vue?vue&type=template&id=52071f40&scoped=true"
import script from "./AddDevice.vue?vue&type=script&lang=js"
export * from "./AddDevice.vue?vue&type=script&lang=js"

import "./AddDevice.vue?vue&type=style&index=0&id=52071f40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52071f40"]])

export default __exports__